/** 가격을 입력받는 유형인가. 나눔은 공짜라 가격이 없다. */
export function allowsPrice(tradeType) {
    return tradeType === 'sell';
}
/** 가격 표기. 빈 문자열이면 화면에서 가격 줄 자체를 그리지 않는다. */
export function formatPrice(price, tradeType) {
    if (tradeType === 'free')
        return '나눔';
    if (tradeType === 'exchange')
        return '교환';
    // 장터가 아닌 글(알립니다·수다)과 폐지된 유형(buy·rent, 소프트삭제 전 잔존 데이터)은
    // 가격 개념이 없다 — "가격 협의"가 붙으면 안 된다.
    if (tradeType !== 'sell')
        return '';
    if (price === null || price === 0)
        return '가격 협의';
    return `${price.toLocaleString('ko-KR')}원`;
}
/** 거래가 끝난 글은 목록에서 흐리게 + 취소선(PRD 5절). */
export function isTradeClosed(tradeStatus) {
    return tradeStatus === 'sold';
}
export const POST_LIMITS = {
    titleMax: 120,
    bodyMax: 20000,
    /** 목록 발췌 길이 */
    excerptMax: 120,
    pageSize: 20,
    /** 글당 이미지 수. "다중 이미지 갤러리 고도화"는 범위 밖(PRD 10절). */
    maxImages: 5,
    maxImageBytes: 5 * 1024 * 1024,
};
/** AI 작성 지원 초안 본문 최대 길이(공백 포함). */
export const AI_DRAFT_BODY_MAX = 140;
/** 글 한 편 작성 중 AI 초안을 쓸 수 있는 최대 횟수(작성 세션 기준). */
export const AI_DRAFT_MAX_USES = 5;
/**
 * AI 초안 말투 선택(badge). value는 서버 검증·프롬프트 매핑에, label은 칩 표시에 쓴다.
 */
export const DRAFT_STYLES = [
    { value: 'default', label: '기본' },
    { value: 'polite', label: '정중하게' },
    { value: 'cute', label: '귀엽게' },
    { value: 'cool', label: '쿨하게' },
];
//# sourceMappingURL=post.js.map